<template>
    <div class="row">
        <template v-for="(prod, prodIndex) in products">
            <div class="col-sm-4 text-center">
                <div class="img-box">
                    <div class="img-wrap">
                        <router-link :to="{ name: 'Product', params: { id: prodIndex }}">
                            <img v-bind:src="'images/catalog/' + campaign.short_url + '/' + prod.item_image_default"/>
                        </router-link>
                    </div>
                </div>
                <p class="product-title">
                    <router-link :to="{ name: 'Product', params: { id: prodIndex }}">
                        <span v-html="prod.description"></span>
                    </router-link>
                </p>
                <p class="price">$&nbsp;{{ prod.price }}</p>
            </div>
        </template>
    </div>
</template>

<script type="text/jsx">
    import CampaignConfigurationMixin from '../../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    export default {
        name: 'catalog',
        mixins: [
            CampaignConfigurationMixin
        ],
        computed: {
            campaign: function () {
                return this.$store.state.campaign
            },
            products: function () {
                return this.$store.getters.products
            }
        }
    }
</script>

<style lang="scss" scoped>
    .gift-cert {
        height:250px;

        .img-box {
            margin: 30px 0 25px;

            .img-wrap {
                display:block !important;
                height:auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Catalog.vue?212d246b